import Timer from 'slotworks/utils/timer';
import * as TweenJS from 'slotworks/utils/tween';

interface Interval {
    time: number;
    scaleStart?: number;
    scaleEnd?: number;
    wait: boolean;
    easing?: (k: number) => number;
}

export default class Poster extends PIXI.Sprite {
    private currentIndex: number = 0;
    private startTime: number;
    private endTime: number;
    private duration: number;

    private scaleStart: number;
    private scaleEnd: number;

    private easing: (k: number) => number;

    public intervals: Interval[] = [
        {
            time: 1000,
            scaleStart: 0,
            scaleEnd: 1,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        },
        {
            time: 500,
            wait: true
        },
        {
            time: 1000,
            scaleStart: 1,
            scaleEnd: 0,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        }
    ];

    public init() {
        this.intervals = INTERVALS[Math.floor(Math.random() * INTERVALS.length)];
        this.startTime = 0;
        this.scale.set(0, 0);
        this.nextStage();
    }

    public update() {
        if (this.currentIndex >= this.intervals.length) {
            return;
        }
        if (Timer.time > this.endTime) {
            this.currentIndex++;
            this.nextStage();
        } else {
            if (!this.intervals[this.currentIndex].wait) {
                let elapsed = (Timer.time - this.startTime) / this.duration;
                elapsed = this.duration == 0 || elapsed > 1 ? 1 : elapsed;
                const value = this.easing(elapsed); 

                const scale = this.scaleStart + (this.scaleEnd - this.scaleStart) * value;
                this.scale.set(scale, scale);
            }
        }
    }

    public finished() {
        return this.currentIndex >= this.intervals.length;
    }

    private nextStage() {
        if (this.currentIndex < this.intervals.length) {
            this.startTime = Timer.time;
            this.duration = this.intervals[this.currentIndex].time;
            this.endTime = this.startTime + this.duration;
            this.scaleStart = this.intervals[this.currentIndex].scaleStart;
            this.scaleEnd = this.intervals[this.currentIndex].scaleEnd;
            this.easing = this.intervals[this.currentIndex].easing || TweenJS.Easing.Linear.None;
        }
    }
}

const INTERVALS: Interval[][] = [
    [
        {
            time: 200 + Math.random() * 400,
            wait: true
        },
        {
            time: 600 + Math.random() * 100,
            scaleStart: 0,
            scaleEnd: 1,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        },
        {
            time: 200,
            scaleStart: 1,
            scaleEnd: 1.1,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        },
        {
            time: 300 + Math.random() * 500,
            wait: true
        },
        {
            time: 550,
            scaleStart: 1.1,
            scaleEnd: 0,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        }
    ],

    [
        {
            time: 400 * Math.random(),
            wait: true
        },
        {
            time: 700,
            scaleStart: 0,
            scaleEnd: 1.05,
            wait: false,
            easing: TweenJS.Easing.Sinusoidal.In
        },
        {
            time: 400 + Math.random() * 500,
            wait: true
        },
        {
            time: 600,
            scaleStart: 1.05,
            scaleEnd: 0,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        }
    ],

    [
        {
            time: 500 * Math.random(),
            wait: true
        },
        {
            time: 500,
            scaleStart: 0,
            scaleEnd: 1,
            wait: false,
            easing: TweenJS.Easing.Sinusoidal.In
        },
        {
            time: 200,
            scaleStart: 1,
            scaleEnd: 1.1,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        },
        {
            time: 300 + Math.random() * 600,
            wait: true
        },
        {
            time: 550,
            scaleStart: 1.05,
            scaleEnd: 0,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        }
    ],

    [
        {
            time: 500 * Math.random(),
            wait: true
        },
        {
            time: 600,
            scaleStart: 0,
            scaleEnd: 1,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        },
        {
            time: 400 + 600 * Math.random(),
            wait: true
        },
        {
            time: 550,
            scaleStart: 1,
            scaleEnd: 0,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        }
    ],

    [
        {
            time: 100,
            wait: true
        },
        {
            time: 800,
            scaleStart: 0,
            scaleEnd: 1,
            wait: false,
            easing: TweenJS.Easing.Cubic.Out
        },
        {
            time: 200,
            scaleStart: 1,
            scaleEnd: 1.05,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        },
        {
            time: 300 + 600 * Math.random(),
            wait: true
        },
        {
            time: 550,
            scaleStart: 1.05,
            scaleEnd: 0,
            wait: false,
            easing: TweenJS.Easing.Linear.None
        }
    ]
];



// WEBPACK FOOTER //
// ./src/components/poster-transition/poster.ts